import { render, staticRenderFns } from "./ContractNotification.vue?vue&type=template&id=536e7808&"
import script from "./ContractNotification.js?vue&type=script&lang=js&"
export * from "./ContractNotification.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports